<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> Lenz Tech
              </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">AI Chat</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <div class="chat-wrapper">
          <div class="chat_sidebar" :class="{ 'in': !isSidebarOpen, 'out': isSidebarOpen }">
            <!-- Chats sidebar -->
              <PerfectScrollbar
                class="scroll-area-one"
                :settings="settings"
                @ps-scroll-y="scrollHandle"
                name="chatSidebar"
              >
                <!-- Left Chat Title -->
                <div
                  class="left-chat all-chats justify-content-between align-items-center"
                >
                  <div class="setting-title-head" href="#sidebar">
                    <h4>{{ $t('chat_history') }}</h4>
                  </div>

                  <div id="chat-history" class="sidebar-body chat-body" :key="'sideBar-' + titleKey">
                    <div class="justify-content-between align-items-center ps-0 pe-0" v-for="(chatHistory, chatDate) in chatTitleHistory">
                      <div class="fav-title pin-chat">
                        <h6>{{ chatDate }}</h6>
                      </div>
                      <ul>
                        <li
                          class="chat-history-item"
                          v-for="historyThread in chatHistory"
                          @mouseenter="hoveredThreadId = historyThread.id"
                          @mouseleave="hoveredThreadId = null"
                        >
                          <a href="javascript:void(0);" class="chat-history-link" @click.prevent="loadChat(historyThread.id)">
                            {{ historyThread.title }}
                          </a>
                          <!-- ✏️ CHANGED: button has no border/outline/background -->
                          <button
                            v-if="hoveredThreadId === historyThread.id"
                            class="chat-delete-btn"
                            @click.prevent="deleteChat(historyThread.id, chatDate)"
                            title="Delete chat"
                          >
                            <i class="feather-trash-2"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- /Left Chat Title -->
              </PerfectScrollbar>
            <!-- / Chats sidebar -->
          </div>

          <!-- Content Starts -->
            <AIChatBotComponent :currentChatThread="currentChatThread" :isSidebarOpen="isSidebarOpen" @chatCompleted="updateChatHistory" @newChat="newChat" @toggleSidebar="isSidebarOpen=!isSidebarOpen"></AIChatBotComponent>
          <!-- /Content End -->
          </div>

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
  import service from '@/utils/request.js';
  import AIChatBotComponent from "@/components/component/AIChatComponent.vue";
  import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";
  import { PerfectScrollbar } from "vue2-perfect-scrollbar";
  import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
  import {mapState} from "vuex";
  import {deepCopy, summarizeMessages} from "@/utils";

  export default {
    name: "AIChatbot",
    components: {
      FingerPrintSpinner,
      AIChatBotComponent,
      PerfectScrollbar,
    },
    data() {
      return {
        settings: {
          suppressScrollX: true,
        },
        currentChatThread: {id: null, chat_date: '', title: '', content: [], send_messages: []},
        newChatThread: {id: null, chat_date: '', title: '', content: [], send_messages: []},
        chatDb: null, // LocalForage instance
        chatHistory: [], // Array to store chat messages
        chatTitleHistory: [],
        chatHistoryGrouped: {}, // Grouped chat history for the sidebar
        titleKey: 0,
        isSidebarOpen: window.innerWidth < 768,
        hoveredThreadId: null
      }
    },
    created() {
    },
    beforeDestroy() {
      // Example: Remove event listeners or cancel subscriptions
      this.currentChatThread.created_by = this.username
      this.uploadChatHistory(this.currentChatThread);
    },
    computed: {
      ...mapState({
        username: state => state.user.username,
      }),
    },
    async mounted() {
      await this.getChatHistory();

      // Save chat every 5 minutes
      setInterval(this.saveCurrentChat, 5 * 60 * 1000);
    },
    updated ()
    {
    },
    methods: {
      async newChat() {
        if (!this.currentChatThread.created_by) this.currentChatThread.created_by = this.username
        if (!this.currentChatThread.title) this.currentChatThread.title = await summarizeMessages(this.currentChatThread.send_messages, 10)
        await this.uploadChatHistory(this.currentChatThread)
        this.currentChatThread = deepCopy(this.newChatThread)
      },
      groupChatHistory() {
        this.chatTitleHistory = {}
        const dateList = Array.from(new Set(this.chatHistory.map(thread => thread.chat_date)))
        dateList.sort((dateA, dateB) => new Date(dateB) - new Date(dateA))
        dateList.forEach(date => this.chatTitleHistory[date] = [])
        this.chatHistory.forEach(chat => this.chatTitleHistory[chat.chat_date].push({id: chat.id, title: chat.title}))

        // // Use a Map to maintain the insertion order of dates
        // const groupedMap = new Map();
        //
        // this.chatHistory.forEach((item) => {
        //   const dateOnly = item.chat_date
        //   // Extract the date part (YYYY-MM-DD) from the datetime string if necessary
        //   // Adjust this according to your date format
        //   // const dateOnly = typeof item.date === 'string' && item.date.includes('T')
        //   //   ? item.date.split('T')[0]
        //   //   : item.date;
        //
        //   if (!groupedMap.has(dateOnly)) {
        //     // If the date is not yet a key in the map, add it with an empty history array
        //     groupedMap.set(dateOnly, []);
        //   }
        //
        //   // Push the current item into the corresponding history array
        //   groupedMap.get(dateOnly).push({id: item.id, title: item.title});
        // });
        //
        // // Convert the Map into the desired array format
        // // this.chatTitleHistory = Array.from(groupedMap, ([date, history]) => ({
        // //   date,
        // //   history,
        // // }));
        // this.chatTitleHistory = Object.fromEntries(groupedMap)
        //
        // // Sort the groupedArray in descending order based on the date
        // this.chatTitleHistory.sort((a, b) => {
        //   const dateA = new Date(a.date);
        //   const dateB = new Date(b.date);
        //   return dateB - dateA; // For descending order
        // });
      },
      async getChatHistory() {
        service.request({
          url: `/todos/v1/chat_history/${this.username}/`,
          method: 'GET',
        }).then((response) => {
          this.chatHistory = response.data
          this.groupChatHistory(this.chatHistory)
        })
      },
      updateChatHistory(chatThread) {
        if (!chatThread.created_by) chatThread.created_by = this.username
        if (!chatThread.chat_date) chatThread.chat_date = new Intl.DateTimeFormat('en-CA').format(new Date())
        if (!chatThread.id) this.uploadChatHistory(chatThread)
        else {
          const existingThread = this.chatHistory.find(thread => thread.id === this.currentChatThread.id)
          if (!existingThread) {
            this.chatHistory.push(chatThread)
          } else {
            this.chatHistory[existingThread] = chatThread
          }
          if (chatThread.chat_date in this.chatTitleHistory) {
            const chatExists = this.chatTitleHistory[chatThread.chat_date].find(thread => thread.id === chatThread.id)
            if (!chatExists) this.chatTitleHistory[chatThread.chat_date].unshift({
              id: chatThread.id,
              title: chatThread.title
            })
            this.titleKey += 1
          } else {
            const newChatTitle = {}
            newChatTitle[chatThread.chat_date] = [{id: chatThread.id, title: chatThread.title}]
            this.chatTitleHistory = {...newChatTitle, ...this.chatTitleHistory}
            this.titleKey += 1
          }
        }
      },
      async uploadChatHistory(chatThread) {
        let url = `/todos/v1/chat_history/`
        if (chatThread.content && chatThread.content.length ===0) return
        if (chatThread.id) {
          url = `/todos/v1/update_chat_history/${chatThread.id}/`
        }
        if (!chatThread.title || chatThread.title === 'Temporary Title') chatThread.title = await summarizeMessages(chatThread.send_messages, 10)
        await service.request({
          url: url,
          method: 'POST',
          responseType: 'json',
          data: chatThread,
        }).then((response) => {
          this.currentChatThread = response.data
          this.updateChatHistory(response.data)
        })
      },
      scrollHandle() {},
      deleteChat(threadID, chatDate) {
        this.$confirm(
          {
            message: `Sicher, dass das Chat gelöscht wird?`,
            button: {
              no: 'Nein',
              yes: 'Ja'
            },
            callback: confirm => {
              if (confirm) {
                try {
                  service.request({
                    url: `/todos/v1/delete_chat_history/${threadID}/`,
                    method: 'DELETE',
                  })
                  // Remove from chatHistory array
                  this.chatHistory = this.chatHistory.filter(thread => thread.id !== threadID)
                  // Remove from chatTitleHistory sidebar
                  if (this.chatTitleHistory[chatDate]) {
                    this.chatTitleHistory[chatDate] = this.chatTitleHistory[chatDate].filter(thread => thread.id !== threadID)
                    // Clean up empty date groups
                    if (this.chatTitleHistory[chatDate].length === 0) {
                      this.$delete(this.chatTitleHistory, chatDate)
                    }
                  }
                  this.titleKey += 1
                  // If the deleted chat is currently open, reset to a new chat
                  if (this.currentChatThread.id === threadID) {
                    this.currentChatThread = deepCopy(this.newChatThread)
                  }
                } catch (e) {
                  this.$vToastify.error('Fehler beim Löschen des Chats!')
                }
              }
            }
          }
        )
      },
      // Load a chat from History
      async loadChat(threadID) {
        const chatThread = this.chatHistory.filter(thread => thread.id === threadID)
        if (chatThread.length > 0) this.currentChatThread = chatThread[0]
        else this.$vToastify.error('Chat Historie existiert nicht!')
      },
    }
  }
</script>
<style scoped>
.chat_sidebar {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  z-index: 99;
  max-width: 20rem;
}

.chat_sidebar.in {
  margin-left: 0;
}

.chat_sidebar.out {
  margin-left: -20rem;
}

@media (max-width: 787px) {
  .chat_sidebar {
    margin-left: -20rem;
  }
}

.chat-wrapper {
  display: flex;
}

.left-chat {
  height: 60rem;
}

.chat-history-item {
  display: flex;
  align-items: center;
  padding-left: 15px;
  margin-bottom: 10px;
  width: 100%;
}

.chat-history-link {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 14rem;
}

/* ✏️ ADDED: no border, no outline, no background on delete button */
.chat-delete-btn {
  flex-shrink: 0;
  background: none;
  border: none;
  outline: none;
  box-shadow: none;
  padding: 0 6px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}

.chat-delete-btn:hover {
  color: #e74c3c;
}

.chat-delete-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
